import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Logout from "./components/Logout/Logout";
import Home from "./pages/Home";
import Capabilities from "./pages/Capabilities";
import CapabilityExample from "./pages/CapabilityExample";


export default function AppRoutes() {
    const location = useLocation();

    return (
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            {/* Readable without signing in: the reader is deciding whether to evaluate the product. */}
            <Route exact path="/capabilities" element={<Capabilities />} />
            <Route path="/capabilities/:slug" element={<CapabilityExample />} />
            <Route exact path="/logout" element={<Logout />} />
            <Route path="/*" element={<Navigate to="/" replace state={{
                referrer: {
                    pathname: location.pathname,
                    search: location.search,
                },
            }} />} />
        </Routes>
    );
}
